/* FÉNIX R07.41 — recommendation selector state authority. R07.72: FLIP disabled on compact/touch. */
(function(){'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  ready(function(){
    if(document.querySelector('[data-fnxr07-noopept]'))return;
    var stages=document.querySelectorAll('[data-r07-related-dynamic]');
    if(!stages.length)return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function compact(){
      if(!window.matchMedia)return window.innerWidth<=760;
      return window.matchMedia('(max-width:760px)').matches||window.matchMedia('(max-width:1180px) and (hover:none) and (pointer:coarse)').matches;
    }
    stages.forEach(function(stage){
      if(stage.dataset.r07RelatedV41Bound==='1')return;
      stage.dataset.r07RelatedV41Bound='1';
      var cards=Array.prototype.slice.call(stage.querySelectorAll('[data-r07-related-card]'));
      if(cards.length<2)return;
      function vendorOnly(card){
        var small=card.querySelector('.r07-related-dynamic__copy small');
        if(small)small.textContent=small.textContent.replace(/^SELECCIONADO\s*·\s*/i,'').trim();
      }
      function syncRoles(){
        var alternatives=[];
        cards.forEach(function(card){
          vendorOnly(card);
          var role=card.querySelector('.r07-related-dynamic__role');
          if(card.classList.contains('is-featured')){
            if(role)role.textContent='DESTACADO';
          }else{
            alternatives.push(card);
          }
          var btn=card.querySelector('[data-r07-related-select]');
          if(btn)btn.setAttribute('aria-pressed',card.classList.contains('is-featured')?'true':'false');
        });
        var labels=['COMPARA','OTRA OPCIÓN','EXPLORA TAMBIÉN'];
        alternatives.forEach(function(card,index){
          var role=card.querySelector('.r07-related-dynamic__role');
          if(role)role.textContent=labels[index]||'EXPLORA TAMBIÉN';
        });
      }
      function select(card){
        if(card.classList.contains('is-featured'))return;
        var first=new Map();
        cards.forEach(function(c){first.set(c,c.getBoundingClientRect());});
        cards.forEach(function(c){c.classList.remove('is-featured','is-selected');});
        card.classList.add('is-featured','is-selected');
        syncRoles();
        if(!reduce&&!compact()&&Element.prototype.animate){
          requestAnimationFrame(function(){
            cards.forEach(function(c){
              var a=first.get(c),b=c.getBoundingClientRect();
              if(!a||!b.width||!b.height)return;
              var dx=a.left-b.left,dy=a.top-b.top;
              var sx=a.width/Math.max(1,b.width),sy=a.height/Math.max(1,b.height);
              c.animate([
                {transform:'translate('+dx+'px,'+dy+'px) scale('+sx+','+sy+')',transformOrigin:'top left'},
                {transform:'translate(0,0) scale(1,1)',transformOrigin:'top left'}
              ],{duration:460,easing:'cubic-bezier(.16,1,.3,1)'});
            });
          });
        }
      }
      cards.forEach(function(card){
        var btn=card.querySelector('[data-r07-related-select]');
        if(btn)btn.addEventListener('click',function(){select(card);});
      });
      syncRoles();
    });
  });
})();
